
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import CircleIcon from '@components/shared/icons/CircleIcon.vue';
import LetterIcon from '@components/shared/icons/LetterIcon.vue';

@Component({
  name: 'ErrorBox',
  components: {
    CircleIcon,
    LetterIcon
  }
})
export default class ErrorBox extends Vue {

}
